/** API 베이스 URL.
 * 개발(npm start): `http(s)://접속한호스트:4000/api` 직접 호출.
 * 운영(build): 기본 `/api` (nginx reverse-proxy 권장), 필요 시 `REACT_APP_API_BASE_URL`로 오버라이드.
 */
export const getApiBaseUrl = () => {
    const fromEnv = String(process.env.REACT_APP_API_BASE_URL || '').trim().replace(/\/+$/, '');
    if (fromEnv) {
        // HTTPS 페이지에서 http API를 강제로 막아 Mixed Content 오류를 예방한다.
        if (typeof window !== 'undefined' && window.location?.protocol === 'https:' && /^http:\/\//i.test(fromEnv)) {
            return '/api';
        }
        return fromEnv;
    }
    // 개발: 항상 상대 경로 → CRA `setupProxy`가 4000으로 넘김 (localhost/127.0.0.1 혼용·캐시 이슈 방지)
    if (process.env.NODE_ENV === 'development') {
        return '/api';
    }
    return '/api';
};

/** fetch 응답 본문을 JSON으로 읽음. HTML·비JSON이면 명확한 오류(Unexpected token '<' 방지). */
export async function readJsonResponse(response) {
    const rawText = await response.text();
    const trimmed = rawText.trim();
    if (trimmed.startsWith('<')) {
        const isMissingApiRoute = /Cannot (GET|PUT|POST|DELETE) \/api\//i.test(trimmed)
            || (response.status === 404 && trimmed.includes('<!DOCTYPE'));
        if (isMissingApiRoute || /Cannot POST \/api\/as-repair-cases/i.test(trimmed)) {
            throw new Error(
                'API 경로를 찾지 못했습니다. 4000 포트에 구버전 node 프로세스가 남아 있을 수 있습니다. 작업 관리자에서 종료한 뒤 `cd server` → `node index.js` 로 최신 서버를 실행하고, `npm start` 개발 서버도 재시작해주세요.'
            );
        }
        throw new Error(
            '서버가 JSON 대신 HTML을 반환했습니다. 백엔드(`cd server` → `node index.js`, 포트 4000) 실행 여부와 `npm start` 재시작을 확인해주세요. build 폴더만 열면 API가 동작하지 않습니다.'
        );
    }
    let data;
    try {
        data = trimmed ? JSON.parse(trimmed) : null;
    } catch (e) {
        throw new Error(`서버 응답을 JSON으로 읽을 수 없습니다 (HTTP ${response.status}).`);
    }
    if (!response.ok) {
        const msg = (data && (data.message || data.error)) || `요청 실패 (HTTP ${response.status})`;
        throw new Error(msg);
    }
    return data;
}
